import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { ModalError, ModalSuccess } from "components";
import { hardBaseUrl } from "../../../services/urlConstant";
import FormInvoice from "./Components/FormInvoice";
import { downloadFileFromRes, getErrors } from "utils";
import Swal from "sweetalert2";

function AddInvoice() {
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  // Helper untuk menangani download validasi saat terjadi error
  const handleValidationDownload = async (payload, headers) => {
    const isUsage = payload.type === "usage";

    // 1. Siapkan Parameter (Gunakan .map().join() untuk format URL yang aman)
    const ids = isUsage
      ? payload.songs.map(s => s.song_id).join(",")
      : payload.header_ids;

    const queryParam = isUsage ? "song_ids" : "header_ids";
    const url = `${hardBaseUrl}/publisher/transaction/v2/sales-invoice/export-validation?${queryParam}=${ids}`;

    try {
      const res = await axios.get(url, { headers, responseType: "blob" });
      downloadFileFromRes(res);
    } catch (err) {
      console.error("Gagal mendownload file validasi:", err);
    }
  };

  const handlSubmitData = async payload => {
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([, value]) => value !== "")
    );
    try {
      setLoadingPage(true);
      await axios.post(
        `${hardBaseUrl}/publisher/transaction/v2/sales-invoice`,
        filteredPayload,
        { headers }
      );
      ModalSuccess("Invoice has been created").then(() => history.goBack());
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.[0]?.message ||
        error.response?.data?.errors.message ||
        "Terjadi kesalahan";

      const { isConfirmed } = await Swal.fire({
        customClass: { container: "swal-container" },
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // 4. Jika user klik OK, jalankan proses download validasi
      if (
        isConfirmed &&
        errorMessage ===
          "Some songs is removed from catalogue. Download this detail and update the catalogue."
      ) {
        await handleValidationDownload(filteredPayload, headers);
      }
    } finally {
      setLoadingPage(false);
    }
  };

  return (
    <FormInvoice
      pageTitle="Create Invoice"
      pageSubTitle="Create your transaction here"
      loadingPage={loadingPage}
      onSubmitPayload={handlSubmitData}
      setLoadingPage={setLoadingPage}
    />
  );
}

export default AddInvoice;
